import React from 'react'
import { arrayOf, number, shape, string } from 'prop-types'
import { css } from '@emotion/core'
import { useContainerWidth, H3 } from '@fs/zion-ui'
import ComparisonPanel from '../ComparisonPanel/ComparisonPanel'
import Event from './Event'
import { SOLID, NONE } from '../ComparisonPanel/ComparisonPanelBackgroundTypes'
import { useDSCState } from '../../../../../state/DSCStore'
import { useAamState } from '../../../state/AamStore'
import { getGender } from '../../../../../shared/helpers/person_Helper'
import { useComparisonByYear } from '../../../hooks/hooks'

export default function EventComparison({
  id,
  imageUrl,
  header,
  comparisonTargetPerson,
  tileContentData,
  tileComparisonContent,
  year,
  comparisonYear,
  headingWithIcon,
  tileData,
  portraitThumbnailLink,
}) {
  const atWidth = useContainerWidth()
  const dscState = useDSCState()
  const aamState = useAamState()
  const showComparison = useComparisonByYear(aamState, comparisonTargetPerson, dscState, tileData, comparisonYear)
  const eventContainerStyle = css`
    display: flex;
    justify-content: center;
    align-items: ${atWidth({ default: 'center', lg: '' })};
    width: 100%;
    flex-direction: ${atWidth({ default: 'column-reverse', lg: 'row' })};
    margin-top: ${atWidth({ default: '10px', lg: '20px' })};
    outline: none;
  `
  const background = showComparison ? SOLID : NONE // Don't show a background if there isn't a comparisonTarget, or the comparisonTarget is the user
  return (
    <>
      <div css={{ padding: '10px' }}>
        {(!comparisonYear || comparisonYear === tileData?.year) && <H3 centered>{tileData.year}</H3>}
        <H3 centered>{headingWithIcon}</H3>
      </div>
      <div
        data-testid="event-comparison"
        css={eventContainerStyle}
        onKeyPress={(event) => event.stopPropagation()}
        onClick={(event) => event.stopPropagation()}
        role="button"
        tabIndex="-1"
      >
        <ComparisonPanel gender={tileData?.gender?.toLowerCase()} background={background}>
          <Event
            year={year}
            id={id}
            events={tileContentData}
            imageUrl={imageUrl}
            header={header}
            styling={{ padding: '10px' }}
            thumbnailIcon={portraitThumbnailLink ?? ''}
            person={{ atn: tileData.atn, dob: year }}
            gender={tileData?.gender?.toLowerCase()}
            showPersonBlock={showComparison}
          />
        </ComparisonPanel>
        {showComparison && (
          <ComparisonPanel
            gender={
              comparisonTargetPerson?.gender
                ? comparisonTargetPerson?.gender.toLowerCase()
                : getGender(comparisonTargetPerson?.genderType)
            }
            background={SOLID}
          >
            <Event
              id={id}
              year={comparisonYear}
              events={tileComparisonContent}
              imageUrl={imageUrl}
              header={header}
              styling={{ padding: '10px' }}
              gender={
                comparisonTargetPerson?.gender
                  ? comparisonTargetPerson?.gender.toLowerCase()
                  : getGender(comparisonTargetPerson?.genderType)
              }
              thumbnailIcon={comparisonTargetPerson?.portraitThumbnailLink ?? ''}
              person={{ atn: comparisonTargetPerson?.atn, dob: comparisonTargetPerson?.dob }}
              showPersonBlock
            />
          </ComparisonPanel>
        )}
      </div>
    </>
  )
}
EventComparison.propTypes = {
  tileContentData: arrayOf(
    shape({
      category: string,
      categoryId: number,
      endYear: number,
      icon: string,
      id: string,
      languageOnly: string,
      localeOnly: string,
      startYear: number,
      subcategory: string,
      textHeadline: string,
      textTitle: string,
      tileType: string,
      year: number,
    })
  ),
  tileData: shape({
    atn: string,
    gender: string,
    personId: string,
  }),
}
